export const setupOneTrustManagePreferences = function () {
  const triggers = document.querySelectorAll('[data-ot-prefs]')

  if (!triggers.length) {
    return
  }

  triggers.forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault()
      window.OneTrust.ToggleInfoDisplay()
    })
  })
}
